import React, { useState } from "react";
import classes from "./Services.module.css";
import "./Services.css";
import clsx from "clsx";

import {
  blockchainCosultancy,
  blockchainSoftware,
  cloudSolutions,
  cryptoExchange,
  marketingServices,
  mobileDevelopment,
  servicePlatform,
  softwareDevelopment,
} from "../../../images";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button, Heading, SectionHeading, Text } from "../../common";
import { FiPlus } from "react-icons/fi";
import { FaAngleLeft, FaAngleRight, FaArrowRight } from "react-icons/fa6";

const Services = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderData = [
    {
      img: cloudSolutions,
      title: "Cloud  Solutions",
      info: "Tailored, scalable cloud services to enhance business efficiency and security.",
      button: "",
    },
    {
      img: softwareDevelopment,
      title: "Custom Software Development",

      info: "Bespoke software solutions designed for robust performance and scalability.",
      button: "",
    },
    {
      img: cryptoExchange,
      title: "Marketing",
      info: "Strategic marketing solutions to elevate your brand and drive business growth.",
      button: "",
    },
    {
      img: blockchainSoftware,
      title: "Blockchain Software Solutions",
      info: "Secure, innovative blockchain software to revolutionize your digital transactions.",
      button: "",
    },
    {
      img: blockchainCosultancy,
      title: "Blockchain  Consultancy",
      info: "Strategic insights and technical guidance to harness the power of blockchain technology.",
      button: "",
    },
    {
      img: mobileDevelopment,
      title: "Mobile App Development",

      info: "Innovative Android applications focused on user engagement and cutting-edge technology.",
      button: "",
    },
    {
      img: servicePlatform,
      title: "Platform as a  Services",
      info: "Offering an innovative and user-friendly Platform as a Service for swift, one-click app launches",
      button: "",
    },
    {
      img: marketingServices,
      title: "Marketing  Services",
      info: "Providing comprehensive marketing strategies and solutions to amplify your brand's presence and reach.",
      button: "",
    },
  ];
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3.7,
    arrows: true,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow currentSlide={currentSlide} />,
    nextArrow: (
      <CustomNextArrow
        currentSlide={currentSlide}
        slideCount={sliderData.length}
      />
    ),
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3.8,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2.9,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2.2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.9,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1.2,
        },
      },
    ],
  };

  return (
    <section className={classes.wrapper}>
      <div className={clsx(classes.container, "container")}>
        <div className={classes.header}>
          <div className={classes.headingContainer}>
            <SectionHeading heading="Services" />
            <Heading xl5 className={classes.heading}>
              Services to Drive Your Success
            </Heading>
          </div>
          <Text lg className={classes.info}>
            Explore our tailored tech and creative services at SolidHash, where
            we deliver innovative solutions with exceptional craftsmanship.
          </Text>
        </div>
        <div className={classes.services}>
          <Slider {...settings}>
            {sliderData.map((el, i) => (
              <div key={i}>
                <div className={classes.service}>
                  <img src={el.img} className={classes.serviceImg} alt="#" />
                  <div className={classes.titleContainer}>
                    <Heading lg font600 className={classes.title}>
                      {el.title}
                    </Heading>

                    <button className={classes.addButton}>
                      <FiPlus className={classes.plusIcon} />
                    </button>
                  </div>
                  <Text base secondary>
                    {el.info}
                  </Text>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <Button transparent to="#" className={classes.seeAllProductsButton}>
          See all products <FaArrowRight />
        </Button>
      </div>
    </section>
  );
};

export default Services;
const CustomPrevArrow = ({ currentSlide, slideCount, onClick }) => {
  const isActive = currentSlide !== 0; // Check if current slide is not the first slide
  return (
    <button
      onClick={onClick}
      className={clsx(classes.nextButton, isActive && classes.activeButton)}
    >
      <FaAngleLeft className={classes.arrow} />
    </button>
  );
};

const CustomNextArrow = ({ currentSlide, slideCount, onClick }) => {
  const isActive = currentSlide < slideCount - 1; // Check if current slide is not the last slide

  return (
    <button
      onClick={onClick}
      className={clsx(classes.previousButton, isActive && classes.activeButton)}
    >
      <FaAngleRight className={classes.arrow} />
    </button>
  );
};
